import { isValidCnpj as isValidCnpjFormat, isValidCep } from './cnpj'

export const parseCurrencyToNumber = (value) => {
  if (value === null || value === undefined || value === '') return 0
  if (typeof value === 'number') return value

  const normalized = String(value)
    .replace(/\s/g, '')
    .replace(/\./g, '')
    .replace(',', '.')

  const parsed = parseFloat(normalized)
  return Number.isNaN(parsed) ? 0 : parsed
}

export const stripDigits = (value) => String(value || '').replace(/\D/g, '')

const normalizeBoolean = (value) => {
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    if (['', '0', 'false', 'no', 'off'].includes(normalized)) return false
    if (['1', 'true', 'yes', 'on'].includes(normalized)) return true
  }

  return Boolean(value)
}

export const validateAgreement = ({ convenio = {}, priceList = [], requirePriceList = true }) => {
  const errors = {}
  const isPrivate = convenio.is_private === true || convenio.is_private === 1 || convenio.is_private === '1'

  if (!convenio.name || !String(convenio.name).trim()) {
    errors.name = 'Nome do convênio é obrigatório'
  }

  if (!isPrivate && convenio.code_tax_id && Number.isNaN(Number(convenio.code_tax_id))) {
    errors.code_tax_id = 'Código fiscal do convênio é inválido'
  }

  if (convenio.cnpj) {
    const validCnpj = isValidCnpjFormat(convenio.cnpj)

    if (!validCnpj) {
      errors.cnpj = 'CNPJ inválido'
    }
  }

  if (convenio.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(convenio.email).trim())) {
    errors.email = 'E-mail do convênio é inválido'
  }

  const cep = stripDigits(convenio.cep)
  if (convenio.cep && !isValidCep(cep)) {
    errors.cep = 'CEP deve conter 8 dígitos'
  }

  if (convenio.codigo_municipio) {
    const codigoMunicipio = stripDigits(convenio.codigo_municipio)
    if (codigoMunicipio.length !== 7) {
      errors.codigo_municipio = 'Código IBGE do município deve conter 7 dígitos'
    }
  }

  if (convenio.uf && String(convenio.uf).trim().length !== 2) {
    errors.uf = 'UF deve ter 2 caracteres'
  }

  if (requirePriceList && !isPrivate) {
    if (!Array.isArray(priceList) || priceList.length === 0) {
      errors.price_list = 'Inclua ao menos um item na tabela de preços'
    } else {
      const hasInvalidItem = priceList.some((item) => {
        const specialtyId = item?.specialty?.id || item?.specialty_id
        const serviceValue = parseCurrencyToNumber(item?.service_value)
        return !specialtyId || serviceValue <= 0
      })

      if (hasInvalidItem) {
        errors.price_list = 'Tabela de preços contém itens inválidos'
      }
    }
  }

  return errors
}

export const normalizeAgreementPayload = (convenio = {}) => {
  const payload = { ...convenio }
  const isPrivate = payload.is_private === true || payload.is_private === 1 || payload.is_private === '1'
  const aggregateByPatient = payload.aggregate_by_patient ?? payload.mostrar_paciente_relatorio_nfse ?? false

  payload.aggregate_by_patient = normalizeBoolean(aggregateByPatient)
  payload.mostrar_paciente_relatorio_nfse = normalizeBoolean(aggregateByPatient)

  if (!isPrivate) {
    payload.cnpj = stripDigits(payload.cnpj)
    payload.cep = stripDigits(payload.cep)
    payload.codigo_municipio = stripDigits(payload.codigo_municipio)
    payload.uf = String(payload.uf || '').trim().toUpperCase()
  }

  return payload
}
